import React from 'react';
import { Sofa, Building2, Sparkles, Users } from 'lucide-react';

const audiences = [
  {
    icon: Sofa,
    title: 'Interior design studios',
    body: 'Capture client decisions, specifications, approvals, and vendor history.',
  },
  {
    icon: Building2,
    title: 'Architecture teams',
    body: 'Preserve project knowledge across long timelines and changing teams.',
  },
  {
    icon: Sparkles,
    title: 'Boutique firms',
    body: 'Create institutional memory without adding operational overhead.',
  },
  {
    icon: Users,
    title: 'Multi-stakeholder projects',
    body: 'Keep decisions connected across clients, consultants, vendors, and internal teams.',
  },
];

const WhoItsForSection = () => {
  return (
    <section className="bg-[#FBF8F7] pt-2 md:pt-4 pb-24 md:pb-28">
      <div className="max-w-[1240px] mx-auto px-6 md:px-10">
        <p className="text-center text-[#7A5A2E] text-[12px] tracking-[0.24em] uppercase mb-12 animate-[fadeUp_0.7s_ease-out_both]">
          Built for design studios and the fabricators they work with: interior designers, architects, millwork and cabinet shops
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {audiences.map((a, i) => {
            const Icon = a.icon;
            return (
              <div
                key={a.title}
                data-testid={`audience-card-${i}`}
                className="bg-[#FAF4EC] border border-[#2A2018]/[0.06] rounded-2xl px-7 py-6 flex items-center gap-5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-15px_rgba(42,32,24,0.18)] animate-[fadeUp_0.7s_ease-out_both]"
                style={{ animationDelay: `${i * 90 + 120}ms` }}
              >
                <span className="w-14 h-14 rounded-full bg-[#F2EADD] flex items-center justify-center flex-shrink-0">
                  <Icon size={26} className="text-[#7A5A2E]" strokeWidth={1.5} />
                </span>
                <div>
                  <h3 className="text-[#1F1812] text-[16px] font-semibold tracking-tight mb-2">{a.title}</h3>
                  <p className="text-[#6B5E4F] text-[13.5px] leading-relaxed">{a.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </section>
  );
};

export default WhoItsForSection;
